module.exports = __webpack_public_path__ + "static/media/field-violet.17f9b0a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/field-violet.svg
// module id = 54
// module chunks = 0